import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RedirectToNiceAdminGuard {
  constructor() {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (route.data['componentRedirect'] === true) {
      return true;
    } else {
      window.location.href = route.data['target'];
      return false;
    }
  }
}
